export const NOTIFY_TEMPLATE_IDS = {
  ActivateAccount: '42df259b-dc49-4a4f-ab31-34f11f5529ea',
  ForgotPassword: 'b1cb11bb-3dd5-4d38-9908-8c87e7b50895',
  ChangedPassword: '',
  ChangeMailAddress: '',
  PersonalDataChange: '',
  OrderConfirmed: '1606ce82-f887-49bd-b3a0-730c092d41b4',
  Cancellation: 'aa69bcfa-a8c7-43fc-89f3-68c374cabd2e',
  SubscriptionOrderConfirmed: '',
} as const;
